import axios from "axios";

async function getCoordinatesOfAddress(address) {
  const response = await axios.get(
    "https://api.opencagedata.com/geocode/v1/json? ",
    {
      params: {
        key: "103fda4edfee402fa23d1d1e4d742132",
        q: address,
        language: "en",
      },
    }
  );

  return response;
}

export default getCoordinatesOfAddress;
